import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = false;

export const openDialogMeteringDeviceAdditionalSlice = createSlice({
 name: 'openDialogMeteringDeviceAdditional',
 initialState,
 reducers: {
  openDialogMeteringDeviceAdditional: (
   state,
   action: PayloadAction<boolean>,
  ) => {
   state = action.payload;
   return state;
  },
 },
});

export const { openDialogMeteringDeviceAdditional } =
 openDialogMeteringDeviceAdditionalSlice.actions;

export default openDialogMeteringDeviceAdditionalSlice.reducer;
